import React from 'react';
import PropTypes from 'prop-types';
import { localize } from 'redux-i18n';
import DigitalAssetsPage from '../components/DigitalAssets/DigitalAssetsPageContainer';
import { getBEMClasses } from '../helpers/cssClassesHelper';
import PageFooterLayout from '../layouts/PageFooterLayout/PageFooterLayout';
import './DigitalAssets.css';

const classes = getBEMClasses('digital-assets-page');

const DigitalAssets = ({ t }) => {
  return (
    <div className={classes()}>
      <div className={classes('content')}>
        <div className={classes('main')}>
          <header className={classes('hero')}>
            <h1 className={classes('title')}>{t('Digital Assets')}</h1>
            <p className={classes('lede')}>
              {t('Browse live token offerings, amounts, and full project profiles.')}
            </p>
          </header>
          <div className={classes('da-root')}>
            <DigitalAssetsPage />
          </div>
        </div>
      </div>
      <div className={classes('footer')}>
        <PageFooterLayout />
      </div>
    </div>
  );
};

DigitalAssets.propTypes = {
  t: PropTypes.func.isRequired
};

export default localize()(DigitalAssets);
